import isNetworkError from 'is-network-error'

const shouldErrorBeLoggedToSentry = (error: Error) => {
  const errorName = (error as Error)?.name

  return errorName !== 'AbortError' && !isNetworkError(error)
}

export default shouldErrorBeLoggedToSentry
